var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{ref:"nav",staticClass:"topic-jumpletters-wrapper",style:({ top: `${_vm.stickyTopPosition}px` }),attrs:{"aria-labelledby":`topic-jumpletters-${_vm.uuid}`}},[_c('span',{staticClass:"a-visually-hidden",attrs:{"id":`topic-jumpletters-${_vm.uuid}`}},[_c('a-label',{attrs:{"path":"jumpletters.nav.label"}})],1),_vm._v(" "),_c('bpb-scroller',{staticClass:"topic-jumpletters",attrs:{"id":"topic-scroller","flickity-config":{
      freeScroll: true,
      contain: true,
      customAccessibility: true,
    }}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }